<template>
    <div class="overview">
        <!-- <myBreadCrumb :urls="JSON.stringify(breadcrumbs)"></myBreadCrumb> -->

        <!-- Top Row of Dashboard Items -->
        <v-row class="mt-2 mb-3">
            <v-col cols="12" md="6" lg="4" xl="3">
                <dashboard-item to="HrTimeSheet" color="blue" icon="mdi-clock"
                    :title="$t('manager_page.overview.timesheet')"
                    :subtitle="$t('manager_page.overview.timesheet_subtitle')"></dashboard-item>
            </v-col>
            <v-col cols="12" md="6" lg="4" xl="3" v-show="leaveAuth.every(element => userClaims.includes(element))">
                <dashboard-item to="ConfirmLeave" color="green" icon="mdi-note-text-outline"
                    :title="$t('manager_page.overview.leave_request')"
                    :subtitle="$t('manager_page.overview.leave_request_subtitle')"></dashboard-item>
            </v-col>

            <v-col cols="12" md="6" lg="4" xl="3" v-show="overtimeAuth.every(element => userClaims.includes(element))">
                <dashboard-item to="ConfirmOvertime" color="blue" icon="mdi-note-text-outline"
                    :title="$t('manager_page.overview.overtime_request')"
                    :subtitle="$t('manager_page.overview.overtime_request_subtitle')"></dashboard-item>
            </v-col>

            <v-col cols="12" md="6" lg="4" xl="3" v-show="businessAuth.every(element => userClaims.includes(element))">
                <dashboard-item to="ConfirmBusiness" color="red" icon="mdi-note-text-outline"
                    :title="$t('manager_page.overview.business_request')"
                    :subtitle="$t('manager_page.overview.business_request_subtitle')"></dashboard-item>
            </v-col>
        </v-row>

        <!-- Charts Layout Row -->
        <v-row>
            <!-- Wide Charts (2 side-by-side on desktop) -->
            <v-col cols="12" md="6" class="py-2">
                <!-- Real-time Employee Graph -->
                <v-card class="rounded-xl white pb-2 overview-card">
                    <v-card-title class="d-flex align-center py-4 px-6">
                        <v-icon left class="overview-icon mr-2" size="24">mdi-chart-line</v-icon>
                        <span class="overview-header-title text-uppercase">
                            {{ $t("manager_page.overview.current_employee_subtitle") }}
                        </span>
                        <v-spacer></v-spacer>
                        <!-- Time Interval Selector -->
                        <div style="width: 100px;" class="mr-2">
                            <v-select v-model="onlineTimeInterval" :items="timeIntervals" dense outlined
                                hide-details color="green darken-3"
                                class="text-caption custom-select"></v-select>
                        </div>
                        <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on" small class="grey--text text--darken-2">
                                    <v-icon size="20">mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense>
                                <v-list-item @click="fetchEventsList">
                                    <v-list-item-title class="text-caption">Làm mới</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-card-title>
                    <v-divider class="mx-6"></v-divider>
                    <v-card-text class="pt-4 px-6">
                        <chart ref="online" :label="$t('manager_page.overview.current_employee_subtitle_chart')"
                            class="mx-auto" :chartData="chartOnlineEmployee"
                            :ratio="this.$vuetify.breakpoint.name == 'xs' ? 1.2 : 2.5" height="200px"
                            chartType="line" :scales="currentEmpScale">
                        </chart>
                    </v-card-text>
                </v-card>
            </v-col>
            
            <v-col cols="12" md="6" class="py-2">
                <!-- TOTAL EMP REPORT -->
                <v-card class="rounded-xl white pb-2 overview-card">
                    <v-card-title class="d-flex align-center py-4 px-6">
                        <v-icon left class="overview-icon mr-2" size="24">mdi-chart-bar</v-icon>
                        <span class="overview-header-title text-uppercase">
                            {{ $t('manager_page.overview.employee_by_month_chart') }}
                        </span>
                        <v-spacer></v-spacer>
                        <!-- Year Selector -->
                        <div style="width: 90px;" class="mr-2">
                            <v-select v-model="totalEmpYear" :items="totalEmpYears" dense outlined hide-details
                                color="green darken-3" class="text-caption custom-select"></v-select>
                        </div>
                        <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on" small class="grey--text text--darken-2">
                                    <v-icon size="20">mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense>
                                <v-list-item @click="fetchTotalEmp">
                                    <v-list-item-title class="text-caption">Làm mới</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-card-title>
                    <v-divider class="mx-6"></v-divider>
                    <v-card-text class="pt-4 px-6">
                        <chart ref="chartTotalEmp" :label="$t('manager_page.overview.employee_by_month_chart')"
                            class="mx-auto" :chartData="chartDataTotalEmp"
                            :ratio="this.$vuetify.breakpoint.name == 'xs' ? 1.2 : 2.5" height="200px"
                            chartType="bar">
                        </chart>
                    </v-card-text>
                </v-card>
            </v-col>

            <!-- Doughnut Charts (3 side-by-side on desktop) -->
            <!-- Education Level Card -->
            <v-col cols="12" md="4" class="py-2">
                <v-card class="rounded-xl white pb-2 overview-card">
                    <v-card-title class="d-flex align-center py-4 px-6"
                        style="word-break: normal; flex-wrap: nowrap;">
                        <v-icon left class="overview-icon mr-2" size="24">mdi-school</v-icon>
                        <span class="overview-header-title text-uppercase">
                            {{ $t('manager_page.overview.employee_education_chart') }}
                        </span>
                        <v-spacer></v-spacer>
                        <div style="width: 140px;">
                            <v-autocomplete color="green darken-3" dense outlined hide-details
                                :items="departments" item-text="name" item-value="code"
                                :label="$t('manager_page.overview.choose_store')" hide-no-data
                                v-model="paramsEdu.departmentCode" clearable class="text-caption custom-select">
                            </v-autocomplete>
                        </div>
                    </v-card-title>
                    <v-divider class="mx-6"></v-divider>
                    <v-card-text class="pt-4 px-6">
                        <v-row align="center" no-gutters>
                            <v-col cols="7" class="pr-2">
                                <div style="max-height: 180px; overflow-y: auto;" class="pr-1 custom-scrollbar">
                                    <div v-for="(item, index) in eduOverviews" :key="index"
                                        class="d-flex align-center justify-space-between py-1 text-caption">
                                        <div class="d-flex align-center" style="min-width: 0;">
                                            <span class="legend-dot mr-2"
                                                :style="{ backgroundColor: chartDataEdu.datasets[0].backgroundColor[index] }"></span>
                                            <span
                                                class="grey--text text--darken-2 font-weight-medium text-truncate">{{
                                                item.name }}</span>
                                        </div>
                                        <span class="font-weight-bold grey--text text--darken-3 ml-2">{{
                                            getPercentage(item.value, eduOverviews) }}%</span>
                                    </div>
                                </div>
                                <div class="grey--text mt-3" style="font-size: 11px !important;">Cập nhật đến
                                    hiện tại</div>
                            </v-col>
                            <v-col cols="5" class="d-flex justify-center position-relative">
                                <chart ref="chart" :chartData="chartDataEdu" chartType="doughnut"
                                    legendPos="none" :ratio="1" height="115px" width="115px"
                                    :chartOptions="{ cutout: '70%' }">
                                </chart>
                                <div class="donut-center-text">
                                    <div class="text-caption font-weight-bold grey--text text--darken-4"
                                        style="line-height: 1.1;">100%</div>
                                    <div class="text-xxs grey--text">Tổng</div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>

            <!-- Position Card -->
            <v-col cols="12" md="4" class="py-2">
                <v-card class="rounded-xl white pb-2 overview-card">
                    <v-card-title class="d-flex align-center py-4 px-6"
                        style="word-break: normal; flex-wrap: nowrap;">
                        <v-icon left class="overview-icon mr-2" size="24">mdi-briefcase</v-icon>
                        <span class="overview-header-title text-uppercase">
                            {{ $t('manager_page.overview.employee_position_chart') }}
                        </span>
                        <v-spacer></v-spacer>
                        <div style="width: 140px;">
                            <v-autocomplete color="green darken-3" dense outlined hide-details
                                :items="departments" item-text="name" item-value="code"
                                :label="$t('manager_page.overview.choose_store')" hide-no-data
                                v-model="paramsPos.departmentCode" clearable class="text-caption custom-select">
                            </v-autocomplete>
                        </div>
                    </v-card-title>
                    <v-divider class="mx-6"></v-divider>
                    <v-card-text class="pt-4 px-6">
                        <v-row align="center" no-gutters>
                            <v-col cols="7" class="pr-2">
                                <div style="max-height: 180px; overflow-y: auto;" class="pr-1 custom-scrollbar">
                                    <div v-for="(item, index) in posOverview" :key="index"
                                        class="d-flex align-center justify-space-between py-1 text-caption">
                                        <div class="d-flex align-center" style="min-width: 0;">
                                            <span class="legend-dot mr-2"
                                                :style="{ backgroundColor: chartDataPos.datasets[0].backgroundColor[index] }"></span>
                                            <span
                                                class="grey--text text--darken-2 font-weight-medium text-truncate">
                                                {{ $t("manager_page.overview.positionGroup." + item.name) }}
                                            </span>
                                        </div>
                                        <span class="font-weight-bold grey--text text--darken-3 ml-2">{{
                                            getPercentage(item.value, posOverview) }}%</span>
                                    </div>
                                </div>
                                <div class="grey--text mt-3" style="font-size: 11px !important;">Cập nhật đến
                                    hiện tại</div>
                            </v-col>
                            <v-col cols="5" class="d-flex justify-center position-relative">
                                <chart ref="chartPos" :chartData="chartDataPos" chartType="doughnut"
                                    legendPos="none" :ratio="1" height="115px" width="115px"
                                    :chartOptions="{ cutout: '70%' }">
                                </chart>
                                <div class="donut-center-text">
                                    <div class="text-caption font-weight-bold grey--text text--darken-4"
                                        style="line-height: 1.1;">100%</div>
                                    <div class="text-xxs grey--text">Tổng</div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>

            <!-- Age overview -->
            <v-col cols="12" md="4" class="py-2">
                <v-card class="rounded-xl white pb-2 overview-card">
                    <v-card-title class="d-flex align-center py-4 px-6"
                        style="word-break: normal; flex-wrap: nowrap;">
                        <v-icon left class="overview-icon mr-2" size="24">mdi-account-group</v-icon>
                        <span class="overview-header-title text-uppercase">
                            {{ $t('manager_page.overview.employee_age_chart') }}
                        </span>
                        <v-spacer></v-spacer>
                        <div style="width: 140px;">
                            <v-autocomplete color="green darken-3" dense outlined hide-details
                                :items="departments" item-text="name" item-value="code"
                                :label="$t('manager_page.overview.choose_store')" hide-no-data
                                v-model="paramsAge.departmentCode" clearable class="text-caption custom-select">
                            </v-autocomplete>
                        </div>
                    </v-card-title>
                    <v-divider class="mx-6"></v-divider>
                    <v-card-text class="pt-4 px-6">
                        <v-row align="center" no-gutters>
                            <v-col cols="7" class="pr-2">
                                <div style="max-height: 180px; overflow-y: auto;" class="pr-1 custom-scrollbar">
                                    <div v-for="(item, index) in ageOverview" :key="index"
                                        class="d-flex align-center justify-space-between py-1 text-caption">
                                        <div class="d-flex align-center" style="min-width: 0;">
                                            <span class="legend-dot mr-2"
                                                :style="{ backgroundColor: chartDataAge.datasets[0].backgroundColor[index] }"></span>
                                            <span
                                                class="grey--text text--darken-2 font-weight-medium text-truncate">{{
                                                item.name }}</span>
                                        </div>
                                        <span class="font-weight-bold grey--text text--darken-3 ml-2">{{
                                            getPercentage(item.value, ageOverview) }}%</span>
                                    </div>
                                </div>
                                <div class="grey--text mt-3" style="font-size: 11px !important;">Cập nhật đến
                                    hiện tại</div>
                            </v-col>
                            <v-col cols="5" class="d-flex justify-center position-relative">
                                <chart ref="chartAge" :chartData="chartDataAge" chartType="doughnut"
                                    legendPos="none" :ratio="1" height="115px" width="115px"
                                    :chartOptions="{ cutout: '70%' }">
                                </chart>
                                <div class="donut-center-text">
                                    <div class="text-caption font-weight-bold grey--text text--darken-4"
                                        style="line-height: 1.1;">100%</div>
                                    <div class="text-xxs grey--text">Tổng</div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog ref="dialog" v-model="timeDialog" :return-value.sync="customDate" persistent width="290px">
            <v-date-picker v-model="customDate" scrollable range>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="timeDialog = false">
                    Cancel
                </v-btn>
                <v-btn text color="primary" @click="$refs.dialog.save(customDate)">
                    OK
                </v-btn>
            </v-date-picker>
        </v-dialog>

        <!-- Floating Chat Icon -->
        <!-- <v-btn fab dark color="green darken-3" fixed bottom right style="bottom: 24px; right: 24px; z-index: 99;" class="elevation-4">
            <v-icon>mdi-message-text</v-icon>
        </v-btn> -->

    </div>
</template>
<script>
import myBreadCrumb from '@/components/BreadCrumb';
import Chart from '@/components/Charts/Chart.vue';
import ApiServices from '../../../components/services/ApiServices';
import http from '../../../components/services/http-common';
import moment from 'moment';
import DashboardItem from '@/components/Dashboard/DashboardItem.vue';
export default {
    components: {
        myBreadCrumb,
        "chart": Chart,
        DashboardItem
    },
    watch: {
        'paramsEdu.departmentCode': {
            handler(val) {
                this.fetchEdu();
            }
        },

        'paramsPos.departmentCode': {
            handler(val) {
                this.fetchPos();
            }
        },
        'paramsAge.departmentCode': {
            handler(val) {
                this.fetchAge();
            }
        },
        'paramsTotalEmp.type': {
            handler(val) {
                this.fetchAge();
            }
        }
    },
    props: ["breadcrumbs", "icon"],
    computed: {
        userClaims() {
            return localStorage.getItem("userClaim").split(',');
        },
        test() {
            return this.leaveAuth.every(element => this.userClaims.includes(element));
        }
    },
    data() {
        return {
            timeMenu: false,
            timeDialog: false,
            customDate: [],
            online: 0,
            leaveAuth: ["module:employment", "request:index"],
            overtimeAuth: ["module:employment", "request:index"],
            businessAuth: ["module:employment", "request:index"],

            //position
            departments: [],
            paramsEdu: {
                departmentCode: null,
            },
            paramsPos: {
                departmentCode: null,
            },
            paramsAge: {
                departmentCode: null,
            },

            paramsTotalEmp: {
                type: "MONTH",
            },

            eduOverviews: [],
            educationHeaders: [
                { text: this.$t('manager_page.overview.education_level'), value: 'name' },
                { text: this.$t('manager_page.overview.employee_count'), value: 'value' },
            ],

            posOverview: [],
            posHeaders: [
                { text: this.$t('manager_page.overview.position'), value: 'name' },
                { text: this.$t('manager_page.overview.employee_count'), value: 'value' },
            ],

            ageOverview: [],
            ageHeaders: [
                { text: this.$t('manager_page.overview.age_group'), value: 'name' },
                { text: this.$t('manager_page.overview.employee_count'), value: 'value' },
            ],

            totalEmpOverviews: [],
            totalEmpHeaders: [
                { text: 'Tháng', value: 'name' },
                { text: this.$t('manager_page.overview.employee_count'), value: 'value' },
            ],
            currentEmpScale:
            {
                y: {
                    beginAtZero: true,
                    ticks: {
                        precision: 0
                    }
                }
            },

            chartType: "pie",
            chartDataEdu: {
                labels: [],
                datasets: [
                    {
                        label: this.$t("manager_page.overview.employee_count"),
                        data: [],
                        backgroundColor: []
                    },
                ],
            },

            chartDataPos: {
                labels: [],
                datasets: [
                    {
                        label: this.$t("manager_page.overview.employee_count"),
                        data: [],
                        backgroundColor: []
                    },
                ],
            },

            chartDataAge: {
                labels: [],
                datasets: [
                    {
                        label: this.$t("manager_page.overview.employee_count"),
                        data: [],
                        backgroundColor: []
                    },
                ],
            },

            chartDataTotalEmp: {
                labels: [
                    this.$t("common.month.t1"),
                    this.$t("common.month.t2"),
                    this.$t("common.month.t3"),
                    this.$t("common.month.t4"),
                    this.$t("common.month.t5"),
                    this.$t("common.month.t6"),
                    this.$t("common.month.t7"),
                    this.$t("common.month.t8"),
                    this.$t("common.month.t9"),
                    this.$t("common.month.t10"),
                    this.$t("common.month.t11"),
                    this.$t("common.month.t12")
                ],
                datasets: [
                    {
                        label: this.$t("manager_page.overview.employee_count"),
                        data: [],
                        backgroundColor: [],
                        borderColor: [],
                        borderWidth: 2,

                    },
                ],
            },
            chartOnlineEmployee: {
                labels: [],
                datasets: [
                    {
                        label: this.$t("manager_page.overview.employee_count"),
                        data: [],
                        cubicInterpolationMode: 'monotone',
                        tension: 0.4,
                        fill: true,
                        backgroundColor: 'rgba(76, 175, 80, 0.1)',
                        borderColor: '#2e7d32',
                        borderWidth: 2,
                        pointBackgroundColor: '#2e7d32',
                        pointBorderColor: '#fff',
                        pointBorderWidth: 2,
                        pointRadius: 5,
                        pointHoverRadius: 7
                    },
                ],
            },
            onlineTimeInterval: "5 phút",
            timeIntervals: ["5 phút", "10 phút", "15 phút", "30 phút"],
            totalEmpYear: new Date().getFullYear(),
            totalEmpYears: [new Date().getFullYear() - 2, new Date().getFullYear() - 1, new Date().getFullYear(), new Date().getFullYear() + 1]
        }
    },
    methods: {
        hslToHex(h, s, l) {
            s /= 100; l /= 100;
            const k = n => (n + h / 30) % 12;
            const a = s * Math.min(l, 1 - l);
            const f = n => {
                const val = l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
                return Math.round(255 * val);
            };
            const r = f(0), g = f(8), b = f(4);
            const toHex = v => v.toString(16).padStart(2, '0');
            return `#${toHex(r)}${toHex(g)}${toHex(b)}`.toUpperCase();
        },
        paletteGolden(n, opts = {}) {
            const {
                seedHue = Math.floor(Math.random() * 360),
                saturation = 62,
                lightness = 54,
                golden = 137.50776405003785 // golden angle in degrees
            } = opts;

            const colors = [];
            let h = seedHue;
            for (let i = 0; i < n; i++) {
                colors.push(this.hslToHex(h % 360, saturation, lightness));
                h += golden;
            }
            return colors;
        },
        getPresetColors(n) {
            const presetColors = [
                '#2e7d32', // Emerald green
                '#66bb6a', // Light green
                '#00838f', // Teal
                '#1976d2', // Blue
                '#ff9800', // Orange
                '#ec407a', // Pink
                '#ab47bc', // Purple
                '#bdbdbd'  // Grey
            ];
            const colors = [];
            for (let i = 0; i < n; i++) {
                colors.push(presetColors[i % presetColors.length]);
            }
            return colors;
        },
        getPercentage(value, list) {
            const total = list.reduce((sum, item) => sum + item.value, 0);
            if (!total) return 0;
            return Math.round((value / total) * 100);
        },
        setMonth() {
            this.params.from = moment().startOf("month").format("YYYY-MM-DD");
            this.params.to = moment().endOf("month").format("YYYY-MM-DD");
        },
        setQuarter() {
            this.params.from = moment().startOf("quarter").format("YYYY-MM-DD");
            this.params.to = moment().endOf("quarter").format("YYYY-MM-DD");
        },

        fetchDepartment() {
            return ApiServices.fetchDepartment().then(res => {
                this.departments = res.data;
            })
        },

        fetchEdu() {
            this.paramsEdu.lang = this.$i18n.locale
            return http.get("employees/overview/education", {
                params: this.paramsEdu
            }).then(res => {
                let jobOverviewResults = res.data;
                this.eduOverviews = res.data;
                this.chartDataEdu.labels = [];
                this.chartDataEdu.datasets[0].data = [];
                this.chartDataEdu.datasets[0].backgroundColor = this.getPresetColors(jobOverviewResults.length);

                jobOverviewResults.forEach(x => {
                    this.chartDataEdu.labels.push(x.name);
                    this.chartDataEdu.datasets[0].data.push(x.value);
                });
                this.$refs.chart.update();
            })
        },

        fetchPos() {
            return http.get("employees/overview/position", {
                params: this.paramsPos
            }).then(res => {
                let result = res.data;
                this.posOverview = res.data;
                this.chartDataPos.labels = [];
                this.chartDataPos.datasets[0].data = [];
                this.chartDataPos.datasets[0].backgroundColor = this.getPresetColors(result.length);
                result.forEach(x => {
                    var translatedName = this.$t("manager_page.overview.positionGroup." + x.name)
                    this.chartDataPos.labels.push(translatedName);
                    this.chartDataPos.datasets[0].data.push(x.value);
                });
                this.$refs.chartPos.update()
            })
        },
        fetchAge() {
            return http.get("employees/overview/age", {
                params: this.paramsAge
            }).then(res => {
                let result = res.data;
                this.ageOverview = res.data;
                this.chartDataAge.labels = [];
                this.chartDataAge.datasets[0].data = [];
                this.chartDataAge.datasets[0].backgroundColor = this.getPresetColors(result.length);
                result.forEach(x => {
                    this.chartDataAge.labels.push(x.name);
                    this.chartDataAge.datasets[0].data.push(x.value);
                });
                this.$refs.chartAge.update()
            })
        },
        fetchTotalEmp() {
            return http.get("employees/overview/total-employee", {
                params: this.paramsAge
            }).then(res => {
                let result = res.data;
                this.totalEmpOverviews = res.data;
                this.chartDataTotalEmp.datasets[0].data = [];
                this.chartDataTotalEmp.datasets[0].backgroundColor = [];
                this.chartDataTotalEmp.datasets[0].borderColor = [];
                const currentMonth = moment().month(); // e.g. July is 6
                result.forEach((x, index) => {
                    this.chartDataTotalEmp.datasets[0].data.push(x.value);
                    if (index <= currentMonth) {
                        this.chartDataTotalEmp.datasets[0].backgroundColor.push('rgba(76, 175, 80, 0.8)');
                        this.chartDataTotalEmp.datasets[0].borderColor.push('#2e7d32');
                    } else {
                        this.chartDataTotalEmp.datasets[0].backgroundColor.push('rgba(240, 240, 240, 0.8)');
                        this.chartDataTotalEmp.datasets[0].borderColor.push('#d0d0d0');
                    }
                });
                this.$refs.chartTotalEmp.update()
            })
        },
        getRandomColor() {
            var letters = '0123456789ABCDEF'.split('');
            var color = '#';
            for (var i = 0; i < 6; i++) {
                color += letters[Math.floor(Math.random() * 16)];
            }
            return color;
        },

        fetchEventsList() {
            return http.get("employeeDashboard/current-emp").then(res => {
                let online = res.data;

                if (this.chartOnlineEmployee.datasets[0].data.length >= 5) {
                    this.chartOnlineEmployee.labels.shift();
                    this.chartOnlineEmployee.datasets[0].data.shift();
                }

                this.chartOnlineEmployee.labels.push(moment().format("HH:mm"));
                this.chartOnlineEmployee.datasets[0].data.push(online);
                this.$refs.online.update()
            })
        },
        cancelAutoUpdate() {
            clearInterval(this.timer);
        }
    },
    created() {
        const HR_DIRECT = false;
        var isHr = localStorage.getItem('userClaim')?.includes('hr:dashboard')
        if (isHr && HR_DIRECT) {
            this.$router.push({ name: 'HrEmployeeOverview' })
        }

        this.fetchDepartment();
        this.fetchEdu();
        this.fetchPos();
        this.fetchAge();
        this.fetchTotalEmp();

        this.fetchEventsList();
        this.timer = setInterval(this.fetchEventsList, 60000);
    },
    beforeDestroy() {
        this.cancelAutoUpdate();
    }

}
</script>

<style scoped>
.overview-header-title {
    color: #1b5e20 !important;
    /* Dark green matching theme */
    font-weight: 700 !important;
    font-size: 13px !important;
    letter-spacing: 0.5px;
}

.overview-icon {
    color: #1b5e20 !important;
}

.legend-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;
    flex-shrink: 0;
}

.donut-center-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    pointer-events: none;
}

.text-xxs {
    font-size: 9px !important;
    line-height: 1;
}

.position-relative {
    position: relative !important;
}

.overview-card {
    border: 1px solid #eef0f3 !important;
    box-shadow: 0 4px 18px rgba(0, 0, 0, 0.025), 0 1px 2px rgba(0, 0, 0, 0.015) !important;
}

.custom-select>>>.v-input__control>>>.v-input__slot {
    min-height: 32px !important;
    padding: 0 8px !important;
    border-color: #e0e0e0 !important;
}

.custom-select>>>.v-select__selection {
    font-size: 11px !important;
}

.custom-scrollbar::-webkit-scrollbar {
    width: 4px;
}

.custom-scrollbar::-webkit-scrollbar-track {
    background: transparent;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
    background: #e0e0e0;
    border-radius: 2px;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
    background: #bdbdbd;
}
</style>